import styled from 'styled-components';
import { responsiveBreakPoints } from '@styles/DesignVariables';
const { maxTablet } = responsiveBreakPoints;

export const ToggleSection = styled.div`
	display: flex;
	flex-direction: column;
	margin: 64px 0 48px 0;
	@media screen and (${maxTablet}) {
		margin: 56px 0 32px 0;
	}
`;

export const DividerLine = styled.div`
	width: 100%;
	height: 1px;
	background: #e0e0e0;
	position: relative;
	cursor: pointer;
`;

export const LabelText = styled.div`
	position: relative;
	color: #4f4f4f;
	text-align: center;
	font-size: 18px;
	line-height: normal;
	margin-top: 48px;
`;

export const ToggleButton = styled.div<{ isOpen: boolean }>`
	position: absolute;
	top: -22px;
	left: 50%;
	transform: translateX(-50%);
	width: 48px;
	height: 48px;
	background: #f9f9f9;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;
	box-shadow: 0 0 0 1px #e0e0e0;
	transition: transform 0.3s ease;

	svg {
		transform: rotate(${(props) => (props.isOpen ? '-180deg' : '0deg')});
		transition: transform 0.3s ease;
	}
`;
